import React, { useState } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata,
  columns,

  // Search
  search,
  setSearch,

  // Filters
  filters,
  onApplyFilters,
  onClearFilters,

  // Pagination
  currentPage,
  totalRows,
  rowsPerPage,
  onChangePage,
  onChangeRowsPerPage,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);

  const handleApplyFilters = (newFilters) => {
    if (onApplyFilters) {
      onApplyFilters(newFilters);
    }

    setShowFilterModal(false);
  };

  const handleRemoveFilters = () => {
    if (onClearFilters) {
      onClearFilters();
    }

    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      {/* =====================================================
          SEARCH + FILTER
      ====================================================== */}

      <div className="row justify-content-between mb-2">
        {/* SEARCH */}

        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder="Search by Asset Name"
            className="form-control"
            value={search || ""}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>

        {/* FILTER */}

        <div className="col-md-9 mb-2">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {/* =====================================================
          SERVER-SIDE DATA TABLE
      ====================================================== */}

      <DataTable
        columns={columns || []}
        data={apidata || []}
        pagination
        paginationServer
        paginationTotalRows={totalRows || 0}
        paginationPerPage={rowsPerPage || 10}
        paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
        paginationDefaultPage={currentPage || 1}
        onChangePage={(page) => {
          if (onChangePage) {
            onChangePage(page);
          }
        }}
        onChangeRowsPerPage={(newPerPage) => {
          if (onChangeRowsPerPage) {
            onChangeRowsPerPage(newPerPage);
          }
        }}
        fixedHeader
        highlightOnHover
        responsive
        persistTableHead
        noDataComponent={<div className="py-3">No Asset Types Found</div>}
      />

      {/* =====================================================
          FILTER MODAL
      ====================================================== */}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        filters={filters}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleRemoveFilters}
      />
    </div>
  );
}
